import { render, staticRenderFns } from "./AddEditWorkload.vue?vue&type=template&id=5eac95ca"
import script from "./AddEditWorkload.vue?vue&type=script&lang=js"
export * from "./AddEditWorkload.vue?vue&type=script&lang=js"
import style0 from "./AddEditWorkload.vue?vue&type=style&index=0&id=5eac95ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports